export default __webpack_public_path__ + "static/media/nextnext.d27a2759.svg";